import { MajorExplorerCapabilityConfiguration } from '../../configuration';

export class MajorSurveyBeginController {
  private iconTheme: string;

  constructor(
    private $state: ng.ui.IStateService,
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration,
    private myIntakeModel: any,
    private _intakeItem: any
  ) {
    this.iconTheme = this.ngMajorExplorerCapabilityConfiguration.config.navIconTheme;

    this.myIntakeModel.initialize(_intakeItem);
    this.myIntakeModel.splitOutRankPage();
  }

  goToSearch(): void {
    this.$state.go('my.majorSearch');
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/views/major_survey_begin/major_survey_begin_controller.ts